// extracted by mini-css-extract-plugin
module.exports =  {"address":"VSRSQpxv_zMXmvBm4cKo","addressGroup":"c2CV4zReik4gXxdvNkg4","alert":"ivm2UV9HWE1uKt4Bikrb","checkbox":"dkOV3wZeSDw0s5poPA6v"};